import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
interface HeroProps {
  onScrollToSection: (sectionId: string) => void;
}
export function Hero({
  onScrollToSection
}: HeroProps) {
  const {
    t
  } = useLanguage();
  return <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-white pt-20" data-id="element-241">
      {/* Subtle grain texture */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{
      backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"%3E%3Cfilter id="noiseFilter"%3E%3CfeTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="3" stitchTiles="stitch"/%3E%3C/filter%3E%3Crect width="100%25" height="100%25" filter="url(%23noiseFilter)"/%3E%3C/svg%3E")'
    }} data-id="element-242" />
      <div className="relative z-10 max-w-5xl mx-auto px-6 py-32 text-center" data-id="element-243">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-8" data-id="element-244">
          <p className="text-xs font-mono tracking-wider uppercase text-gray-600" data-id="element-245">
            {t('hero.badge')}
          </p>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-7xl md:text-8xl lg:text-[12rem] font-black text-black mb-8 leading-none tracking-tighter uppercase" style={{
        fontFamily: 'system-ui, -apple-system, sans-serif',
        fontStretch: 'condensed'
      }} data-id="element-246">
          NEURO
          <span className="inline-block border-b-8 border-gray-300" data-id="element-247">SPICE</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-3xl md:text-4xl text-black mb-6 max-w-2xl mx-auto font-light tracking-wide" data-id="element-248">
          {t('hero.tagline')}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.25
      }} className="mb-8" data-id="element-249">
          <p className="text-xl md:text-2xl text-black font-medium max-w-2xl mx-auto leading-relaxed" data-id="element-250">
            {t('hero.hook')}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mb-16" data-id="element-251">
          <p className="text-lg text-black mb-3 max-w-2xl mx-auto leading-relaxed" data-id="element-252">
            {t('hero.subtitle')}
          </p>
          <p className="text-sm text-gray-600 max-w-xl mx-auto" data-id="element-253">
            {t('hero.impact')}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col items-center gap-4 mb-20" data-id="element-254">
          <button onClick={() => onScrollToSection('waitlist')} className="w-full sm:w-auto px-12 py-5 bg-black text-white font-black text-lg hover:bg-gray-900 border-2 border-black transition-all duration-300 uppercase tracking-widest rounded-full shadow-lg hover:shadow-xl hover:scale-105" data-id="element-255">
            {t('hero.cta.primary')}
          </button>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} className="mt-16" data-id="element-256">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hic7eASxdKGzgKiGf8kCFF/Gemini_Generated_Image_cz0tuacz0tuacz0t.png" alt={t('hero.image.alt')} className="mx-auto max-w-2xl w-full h-auto rounded-lg shadow-2xl" data-id="element-257" />
        </motion.div>
      </div>
    </section>;
}